module.exports = __webpack_public_path__ + "static/media/forexworldwide_logo_transparent_280x50.42dc12df.42dc12df.png";